import AuthContext from "contexts/AuthContext";
import Menu from "menu/Menu";
import Login from "pages/login/Login";
import RecuperarSenha from "pages/login/RecuperarSenha";
import Validacao from "pages/login/Validacao";
import RouterProvider from "provider/RouterProvider";
import publicRoutes from "PublicRoutes";
import { useContext } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

function AppRoutes() {

    const { estaLogado, acoes, listaOpcoes, nomeUsuario, nomeConta, nomeSetor } = useContext(AuthContext);

    if (estaLogado) {

        return (
            <BrowserRouter>
                <RouterProvider>
                    <Menu acoes={acoes} listaOpcoes={listaOpcoes} nomeUsuario={nomeUsuario} nomeConta={nomeConta} nomeSetor={nomeSetor} />
                </RouterProvider>
            </BrowserRouter>
        );
    }

    return (
        <BrowserRouter>
            <RouterProvider>
                <Routes>
                    <Route path="/" element={<Login />} />
                    <Route path="/recuperarsenha" element={<RecuperarSenha />} />
                    <Route path="*" element={<Login />} />
                    {publicRoutes()}
                </Routes>
            </RouterProvider>
        </BrowserRouter>
    );


}

export default AppRoutes;